import { render, staticRenderFns } from "./shipmentDisplayList.vue?vue&type=template&id=75ace107&scoped=true"
import script from "./shipmentDisplayList.vue?vue&type=script&lang=js"
export * from "./shipmentDisplayList.vue?vue&type=script&lang=js"
import style0 from "./shipmentDisplayList.vue?vue&type=style&index=0&id=75ace107&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ace107",
  null
  
)

export default component.exports